import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  root: {
    height: '100%',
    width: '100%',
    position: 'relative',
    backgroundColor: theme.backgrounds.componentBackground,
    color: theme.texts.main,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  rootMobile: {
    height: '100%',
    width: '100%',
    position: 'relative',
    backgroundColor: theme.backgrounds.componentBackground,
    color: theme.texts.main,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  settingsGrid: {
    padding: '0 1rem',
    display: 'grid',
    gridGap: '1.25rem',
    alignItems: 'center',
    justifyItems: 'center',
    height: '100%',
    width: '100%',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr));',
  },
  settingsGridMobile: {
    gridTemplateColumns: 'repeat(auto-fill, 100%)',
  },
  setting: {
    backgroundColor: theme.backgrounds.cardBackground,
    width: 320,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 88,
    padding: '5px 17px',
    borderRadius: 5,
    marginBottom: 40,
  },
  settingMobile: {
    backgroundColor: theme.backgrounds.cardBackground,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 88,
    padding: '0 17px',
    borderRadius: 5,
    marginBottom: 20,
  },
  cardLeftSide: {
    display: 'flex',
    flexDirection: 'column',
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    minHeight: 54,
    background: theme.backgrounds.navigation,
    padding: '0 3%',
    position: 'relative',
    justifyContent: 'space-between',
    marginBottom: 30,
  },
  resetButton: {
    color: '#d50000',
    height: 30,
  },
  timerTitle: {
    fontSize: '18px',
    lineHeight: '21px',
  },
  timerType: {
    fontSize: '14px',
    lineHeight: '16px',
    color: 'rgba(255, 255, 255, 0.5)',
    margin: '3px 0',
  },
  timerDuration: {
    fontSize: '14px',
    lineHeight: '16px',
    color: 'rgba(255, 255, 255, 0.5)',
  },
  backButton: {
    padding: 12,
    marginRight: 18,
  },
}))

export default useStyles
